import styled from 'styled-components'
import { colors, transitions, fontWeights } from '@/styles'

const offsetX = 2
const offsetY = 16
const activeOffsetY = 3

export const active = `
  color: ${colors.regular};
  transform: translate(${offsetX}px, ${activeOffsetY}px);
  font-size: 11px;
  line-height: 18px;
  font-weight: ${fontWeights.medium};
  svg {
    display: none;
  }
`

const Label = styled.label<{ x?: number; y?: number }>`
  transition: ${transitions.floatingLabel};
  position: absolute;
  display: flex;
  align-items: center;
  pointer-events: none;
  font-size: 14px;
  line-height: 18px;
  letter-spacing: -0.2px;
  padding-left: 12px;
  font-weight: ${fontWeights.regular};
  top: 0;
  left: 0;
  ${props => `
    transform: translate(${props.x || offsetX}px, ${props.y || offsetY}px);
  `}
  color: ${colors.mediumGrey};
  svg {
    margin-right: 8px;
  }
`

export default Label
